import React from 'react';

export default function ProfileScreen() {
	return <div>ProfileScreen</div>;
}
